<template>
    <span class="countdown">
        <span v-for="(time, i) in times" :key="i">
            <span class="time">{{ time.time }}</span>
            <span class="text">{{ time.text }}</span>
        </span>
    </span>
</template>
<script lang="ts">
export default {
    data() {
        return {
            times: [
                { id: 0, text: ':', time: '0' },
                { id: 1, text: ':', time: '0' },
                { id: 2, text: '', time: '0' },
            ],
        }
    },
    created: function () {
        this.updateTimer()
    },
    methods: {
        updateTimer() {
            setTimeout(() => {
                const nextMidnight = new Date()
                nextMidnight.setHours(24, 0, 0, 0)
                const t = Date.parse(new Date(nextMidnight).toString()) - Date.parse(new Date().toString())

                this.times[2].time = this.formatTime(Math.floor((t / 1000) % 60))
                this.times[1].time = this.formatTime(Math.floor((t / 1000 / 60) % 60))
                this.times[0].time = this.formatTime(Math.floor((t / (1000 * 60 * 60)) % 24))

                this.updateTimer()
            }, 1000)
        },
        formatTime(num: number) {
            return (num < 10 ? '0' : '') + num
        },
    },
}
</script>

<style lang="scss" scoped>
.countdown {
    .time {
        border-radius: 10px;
        padding: 5px 10px;
        letter-spacing: 10px;
        position: relative;
        z-index: 1;
        display: inline-block;
        line-height: normal;
        width: 77px;
        text-align: center;

        &::after,
        &::before {
            content: '';
            position: absolute;
            z-index: -1;
            top: 5px;
            left: 3px;
            width: 20px;
            height: 30px;
            border-radius: 10px;
            background-color: $color-grey;
        }

        &::after {
            left: 35px;
        }

        &::before {
            left: 12px;
        }
    }
    .text {
        margin-left: -17px;
        margin-right: 1px;
    }
}
</style>
